import { createActions } from 'redux-actions';

const {
  editUserProfile,
  editUserProfileSuccess,
  editUserProfileFailure,
  getProfileById,
  getProfileByIdSuccess,
  getProfileByIdFailure,
  resetEditProfileStatus,
} = createActions(
  'EDIT_USER_PROFILE',
  'EDIT_USER_PROFILE_SUCCESS',
  'EDIT_USER_PROFILE_FAILURE',
  'GET_PROFILE_BY_ID',
  'GET_PROFILE_BY_ID_SUCCESS',
  'GET_PROFILE_BY_ID_FAILURE',
  'RESET_EDIT_PROFILE_STATUS'
);

export {
  editUserProfile,
  editUserProfileSuccess,
  editUserProfileFailure,
  getProfileById,
  getProfileByIdFailure,
  getProfileByIdSuccess,
  resetEditProfileStatus,
};
